const FooterEn = {
    messageUs: "Message Us",
    callUs: "Call Us",
    aboutUs: "About Us",
    service: "Service",
    eventNew: "Event & News",
    contactUs: "Contact Us",
    btn_get_in_touch: "Get in touch",
    btn_company_info: "Company Info",
    btn_company_vision: "Company Vision",
    btn_our_service: "Our Serivce",
    btn_news_event: "Company News And Event",
}

export default FooterEn;